import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { BUS_MAINTENANCE_STAY_PATH } from '../../../../config/paths';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import Loader from '../../../common/Loader';
import NoDataResource from '../../../common/resource/NoDataResource';
import BusMaintenanceStayBasicInformationResource from './resource/BusMaintenanceStayBasicInformationResource';
import {
  clearBusMaintenanceStay,
  getBusMaintenanceStay,
} from '../../../../actions/mechanical-maintenance/BusMaintenanceStay';

export const BusMaintenanceStay = ({
  breadcrumbs,
  dispatchClearBusMaintenanceStay,
  dispatchGetBusMaintenanceStay,
  match: {
    params: { id: busMaintenanceStayId },
  },
  loading,
  busMaintenanceStay,
}) => {
  useLayoutEffect(() => {
    dispatchGetBusMaintenanceStay({ busMaintenanceStayId });

    return () => dispatchClearBusMaintenanceStay();
  }, []);

  let content;

  if (loading) content = <Loader />;
  else if (busMaintenanceStay.isEmpty())
    content = <NoDataResource returnPage={BUS_MAINTENANCE_STAY_PATH} />;
  else {
    const busMaintenanceStayJson = busMaintenanceStay.toJS();
    
    content = (
      <>
        <h3>Información Básica</h3>
        <BusMaintenanceStayBasicInformationResource
          {...busMaintenanceStayJson}
        />
      </>
    );
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Estancia de Mantenimiento por Bus"
      content={content}
    />
  );
};

BusMaintenanceStay.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchClearBusMaintenanceStay: PropTypes.func.isRequired,
  dispatchGetBusMaintenanceStay: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  busMaintenanceStay: PropTypes.instanceOf(Immutable.Map).isRequired,
};

BusMaintenanceStay.defaultProps = {
  loading: false,
};

const mapDispatchToProps = {
  dispatchClearBusMaintenanceStay: clearBusMaintenanceStay,
  dispatchGetBusMaintenanceStay: getBusMaintenanceStay,
};

const mapStateToProps = ({ MechanicalMaintenanceUnit }) => ({
  breadcrumbs: [
    ...MechanicalMaintenanceUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Estancias de Mantenimiento por Bus',
      href: BUS_MAINTENANCE_STAY_PATH,
    },
    {
      text: 'Ver',
      href: '',
    },
  ],
  busMaintenanceStay: MechanicalMaintenanceUnit.BusMaintenanceStay.getIn([
    'current',
    'content',
  ]),
  loading: !MechanicalMaintenanceUnit.BusMaintenanceStay.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

export default connect(mapStateToProps, mapDispatchToProps)(BusMaintenanceStay);
